module.exports = __webpack_public_path__ + "static/img/buy_gongshi.0ecd7369.png";